var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.label
      ? _c("label", {
          staticClass: "block text-sm leading-5 text-gray-700",
          class: { "font-medium": !this.bold, "font-bold": this.bold },
          attrs: { id: _vm.id },
          domProps: { innerHTML: _vm._s(_vm.label) },
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "mt-1 relative rounded-md shadow-sm" }, [
      _c(
        "div",
        {
          staticClass:
            "flex items-center border border-gray-300 rounded-md text-gray-400 px-2 focus-within:shadow-outline-blue",
          class: {
            "border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus-within:shadow-outline-red":
              _vm.error,
          },
        },
        [
          _c(
            "button",
            {
              staticClass: "focus:outline-none hover:text-primary-600",
              on: { click: _vm.decrement },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "w-5 h-5",
                  attrs: {
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M18 12H6",
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "relative w-full" }, [
            _c("input", {
              staticClass:
                "form-input block w-full sm:text-sm sm:leading-5 border-0 focus:shadow-none text-center text-black",
              class: { "pr-10": _vm.error },
              attrs: {
                type: "text",
                id: _vm.id,
                name: _vm.name,
                required: _vm.required,
                readonly: "",
              },
              domProps: { value: _vm.value },
            }),
            _vm._v(" "),
            _vm.error
              ? _c(
                  "div",
                  {
                    staticClass:
                      "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none",
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "h-5 w-5 text-red-500",
                        attrs: { fill: "currentColor", viewBox: "0 0 20 20" },
                      },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
                            "clip-rule": "evenodd",
                          },
                        }),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "focus:outline-none hover:text-primary-600",
              on: { click: _vm.increment },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "w-5 h-5",
                  attrs: {
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M12 6v6m0 0v6m0-6h6m-6 0H6",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "mt-1 text-xs text-red-600" }, [
      _vm._v("\n        " + _vm._s(_vm.error) + "\n    "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }